module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ../node_modules/file-loader?name=favicon.ico!./shared/favicons/favicon.ico
// module id = 1150
// module chunks = 2